<template>
    <div>
        <h2 class="txt-center">페이지를 불러오는 중입니다...</h2>
    </div>
</template>
<script>
export default {
    mounted () {
        sessionStorage.setItem('companyCode', this.$route.params.companyCode);
        sessionStorage.setItem('isAdmin', true);
        localStorage.setItem('companyCode', this.$route.params.companyCode);
        this.$router.push('/user/login');
    }
}
</script>